<template>
  <CommonModal>
    <SpinningLoader :pending="pending">
      <div class="flex flex-col h-full">
        <div class="flex-grow modal-scroll">
          <table class="my-2 text-xs w-full shadow">
            <thead class="sticky top-0">
              <tr>
                <th class="bg-corepla-bg-dark text-white text-xs p-2 font-normal text-left">
                  {{ $t("common.date") }}
                </th>
                <th class="bg-corepla-bg-dark text-white text-xs p-2 font-normal">
                  {{ $t("common.price") }}
                </th>
              </tr>
            </thead>

            <tr
              v-for="history in histories"
              :key="'history-' + lot.uuid + '-' + history.uuid"
            >
              <td class="p-2 text-xs">
                <div class="font-bold">
                  {{ dateUtils.formatWithSeconds(history.bidTime) }}
                </div>
              </td>
              <td class="p-2 text-xs text-center">
                {{ history.currentPrice }} €
              </td>
            </tr>
          </table>
        </div>
        <div>
          <a
            href="#"
            class="btn btn-cancel"
            @click.prevent="$emit('close')"
          >{{ $t("common.close") }}</a>
        </div>
      </div>
    </SpinningLoader>
  </CommonModal>
</template>

<script setup>
import { ref } from 'vue'

import CommonModal from '@/components/CommonModal.vue';
import SpinningLoader from '@/components/SpinningLoader.vue';
import useAxios from '@/composables/axios';
import dateUtils from '@/services/date-utils';

const axios = useAxios()

const emit = defineEmits(['close'])
const props = defineProps({
  lot: {
    type: Object,
    required: true
  },
  auction: {
    type: Object,
    required: true
  }
})

const histories = ref([]);
const pending = ref(true);

axios.get('/auction/bidHistory/' + props.auction.uuid + '/' + props.lot.uuid).then(response => {
  pending.value = false;
  histories.value = response.data;
}).catch(() => {
  emit('close');
})
</script>